<section class="account_section">
  <app-account-nav [email]="email" [name]="name"></app-account-nav>
  <router-outlet></router-outlet>
</section>
